<template>
  <div class="property-select-item" :class="[zsTjTheme]">
    <div ref="select" class="option">
      <span class="left">{{ value || value === 0 ? options[value].label : "" }}</span>
      <span class="right"
        >{{ value || value === 0 ? options[value].value : ""
        }}{{ (value || value === 0) && abcsCalcData[value] ? `+${abcsCalcData[value]}` : "" }}</span
      >
    </div>
    <div v-show="isInit" ref="tippyContent" class="option-list">
      <div v-for="(item, index) in options" :key="index" class="option-item" @click="handleSelect(index)">
        <span class="left">{{ item.label }}</span>
        <span class="right">{{ item.value }}{{ abcsCalcData[index] ? `+${abcsCalcData[index]}` : "" }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import tippy from "@/plugins/tippy";
import { mapGetters } from "vuex";

export default {
  name: "PropertySelectItem",
  props: {
    value: { type: Number, default: undefined },
    options: { type: Array, default: () => [] },
    abcsCalcData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isInit: false
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme"])
  },
  mounted() {
    this.initTippy();
  },
  beforeDestroy() {
    this.tippy.destroy();
  },
  methods: {
    initTippy() {
      const target = this.$refs.select;
      const content = this.$refs.tippyContent;
      if (!target || !content) {
        setTimeout(this.initTippy, 50);
        return;
      }
      this.tippy = tippy(target, {
        content,
        arrow: false,
        interactive: true,
        trigger: "click",
        placement: "bottom",
        theme: "tippy-clear-style-theme"
      });
      this.isInit = true;
    },
    handleSelect(key) {
      this.tippy.hide();
      this.$emit("change", key);
    }
  }
};
</script>
<style lang="less" scoped>
.property-select-item {
  width: 100%;

  .option {
    width: 100%;
    height: 28px;
    border-radius: 4px;
    padding: 0 5px;
    box-sizing: border-box;
    background: #0a0b0c;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: 1px solid #222222;
    .left,
    .right {
      font-weight: 400;
      font-size: 14px;
      line-height: 26px;
      color: #cccccc;
    }
  }

  .option-list {
    display: flex;
    flex-direction: column;
    background-color: #0a0a0c;
    box-sizing: border-box;
    padding: 6px 5px;
    border-radius: 4px;
    width: 180px;
    border: 1px solid #222222;
    .option-item {
      position: relative;
      border-radius: 16px;
      width: 100%;
      height: 27px;
      margin-bottom: 6px;
      padding: 0 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 300ms;
      &:last-child {
        margin-bottom: 0;
      }
      .left,
      .right {
        font-weight: 400;
        font-size: 14px;
        color: #cccccc;
      }
      &:hover {
        background-color: rgba(255, 255, 255, 0.08);
      }
    }
  }
}

.property-select-item.light {
  .option {
    border: 1px solid #d8d8d8;
    background: transparent;
    .left,
    .right {
      color: #333333;
    }
  }

  .option-list {
    border: 1px solid #d8d8d8;
    background: #fff;
    .option-item {
      .left,
      .right {
        color: #333333;
      }
    }
  }
}
</style>
